<template>
  <div id="app">
    <!-- 使用 transition 元素包裹路由出口 -->
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <audio preload autoplay loop id="music"></audio>
  </div>
</template>

<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
import { getData } from '@/assets/device'
// 引入wxjs
import wx from "weixin-js-sdk";
export default {
  name: "App",
  data() {
    return {};
  },
  created() {
    // this.$getShareInfo();
    // this.$getTxtData();
  },
  mounted() {
    getData()
    this.$applyHeights();
    window.addEventListener("resize", this.handleResize);
    // 默认播放音频
    // this.playAudio();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {},
};
</script>

<style scoped lang="less">
/* 定义fade过渡样式 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
